import AiSolution from "@/assets/images/breadcrumbs/mobileapp.webp";
import { Smartphone, Globe, Code2, Layers } from "lucide-react";

const CHIPS = [
	{ icon: <Smartphone size={13} strokeWidth={1.8} />, label: "Mobile Apps" },
	{ icon: <Globe size={13} strokeWidth={1.8} />, label: "Web Applications" },
	{ icon: <Code2 size={13} strokeWidth={1.8} />, label: "Custom Software" },
	{ icon: <Layers size={13} strokeWidth={1.8} />, label: "Full-Stack Dev" },
];

export default function IntroSection() {
	return (
		<section className="relative py-12 md:py-24 overflow-hidden">

			{/* ── Ambient glow ── */}
			<div
				className="absolute top-1/2 right-0 -translate-y-1/2 w-[500px] h-[500px] rounded-full pointer-events-none"
				style={{ background: "radial-gradient(circle, rgba(99,102,241,0.07) 0%, transparent 70%)" }}
			/>
			<div
				className="absolute top-1/4 left-0 w-[400px] h-[400px] rounded-full pointer-events-none"
				style={{ background: "radial-gradient(circle, rgba(6,182,212,0.06) 0%, transparent 70%)" }}
			/>

			<div className="container">
				<div className="grid lg:grid-cols-2 gap-8 lg:gap-20 items-center">

					{/* ── Image ── */}
					<div className="relative order-1 lg:order-none">
						<div
							className="overflow-hidden rounded-2xl h-[240px] sm:h-[320px] md:h-[400px] lg:h-[460px]"
							style={{ boxShadow: "0 32px 64px rgba(0,0,0,0.6)" }}
						>
							<img
								src={AiSolution}
								alt="Application Development at SAN micron"
								className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
							/>
							<div
								className="absolute bottom-0 left-0 right-0 h-24 pointer-events-none"
								style={{ background: "linear-gradient(to top, rgba(0,0,0,0.55), transparent)" }}
							/>
						</div>

						{/* Floating badge — top left */}
						<div
							className="absolute top-4 left-4 rounded-xl px-4 py-3 border hidden sm:flex items-center gap-2.5"
							style={{
								backgroundColor: "#0d0d0d",
								borderColor: "rgba(6,182,212,0.2)",
								boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
							}}
						>
							<div
								className="w-12 h-12 rounded-lg flex items-center justify-center shrink-0"
								style={{ background: "rgba(6,182,212,0.12)", border: "1px solid rgba(6,182,212,0.2)" }}
							>
								<Code2 size={22} style={{ color: "#22d3ee" }} />
							</div>
							<div>
								<p className="text-white text-sm font-bold leading-none">App Development</p>
								<p className="text-sm mt-0.5" style={{ color: "rgba(255,255,255,0.35)" }}>
									Mobile · Web · Custom
								</p>
							</div>
						</div>
					</div>

					{/* ── Content ── */}
					<div className="space-y-4 sm:space-y-5 order-2 lg:order-none">

						{/* Headline */}
						<div>
							<h2 className="text-2xl sm:text-3xl md:text-[2.6rem] font-bold text-white leading-snug">
								Turning Ideas Into
								<br className="hidden md:block" />
								Powerful
								<span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent pl-2">
									Digital Products
								</span>
							</h2>
							<div className="w-12 h-0.5 rounded-full bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 mt-3 sm:mt-4" />
						</div>

						{/* Body */}
						<p
							className="text-sm sm:text-base md:text-lg leading-relaxed"
							style={{ color: "rgba(255,255,255,0.65)" }}
						>
							Whether you need a sleek mobile app, a high-performance web platform,
							or a fully custom software solution — we build it from the ground up
							with clean architecture, modern tech stacks, and pixel-perfect design.
							At <span className="text-white font-semibold">SAN micron</span>, we
							own every stage of your product lifecycle, from wireframe to launch.
						</p>

						{/* Capability chips */}
						<div className="flex flex-wrap gap-1.5 sm:gap-2">
							{CHIPS.map(({ icon, label }) => (
								<span
									key={label}
									className="inline-flex items-center gap-1.5 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-semibold border transition-all duration-200 hover:border-white/20 cursor-default"
									style={{
										color: "rgba(255,255,255,0.5)",
										borderColor: "rgba(255,255,255,0.08)",
										background: "rgba(255,255,255,0.03)",
									}}
								>
									<span style={{ color: "#22d3ee" }}>{icon}</span>
									{label}
								</span>
							))}
						</div>
					</div>

				</div>
			</div>
		</section>
	);
}